/**
Copyright (c) 2022–2026 Podstack.ai
All rights reserved.
Proprietary and Confidential.
Unauthorized copying of this file, via any medium, is strictly prohibited.
This file is part of the Podstack Platform.
*/

// Helpers for the CLI sign-in hand-off (see pages/CliAuthorize.tsx).
//
// The Podstack CLI runs a local HTTP server on a loopback address and opens
// this page to sign in; after login we mint an API token and redirect the
// browser back to that local server with the token. Because we are about to
// put a real credential on the redirect target, that target MUST be a
// loopback http URL - never a public origin - or a malicious page could
// exfiltrate the token by passing its own redirect_uri.

// isLoopbackRedirect reports whether rawUrl is a safe CLI callback target:
// an http URL on a loopback host with an explicit port.
export function isLoopbackRedirect(rawUrl: string): boolean {
  try {
    const u = new URL(rawUrl);
    if (u.protocol !== 'http:') return false;
    const host = u.hostname;
    const loopback = host === '127.0.0.1' || host === 'localhost' || host === '::1' || host === '[::1]';
    if (!loopback) return false;
    if (!u.port) return false;
    return true;
  } catch {
    return false;
  }
}

// buildCliRedirect appends token and state to the loopback callback URL.
// state is echoed back unchanged so the CLI can verify it (CSRF protection).
export function buildCliRedirect(rawUrl: string, token: string, state: string): string {
  const u = new URL(rawUrl);
  u.searchParams.set('token', token);
  if (state) u.searchParams.set('state', state);
  return u.toString();
}
